import ContentPadding from "../ContentConfig/ContentPadding";


export default () => {
  return (
    <>
      <ContentPadding />
    </>
  );
};
